import { Tooltip } from 'antd';
import Styles from './styles';
import React from 'react';

const TooltipTitle = ({ text, description }) => (
  <div>
    <div>{text}</div>
    {description ? <Styles.EllipsisTooltipDescription>{description}</Styles.EllipsisTooltipDescription>: null}
  </div>
);

export default ({ text, description, width = 300 }) => (
  <Tooltip title={(<TooltipTitle text={text} description={description} />)}>
    <Styles.EllipsisText width={width}>{text}</Styles.EllipsisText>
  </Tooltip>
);
